import { default as dashboard7b1Ncpun5UMeta } from "/home/node/pages/dashboard.vue?macro=true";
import { default as districtsZoKyTfNvdAMeta } from "/home/node/pages/districts.vue?macro=true";
import { default as gameSxUetbtjD0Meta } from "/home/node/pages/game.vue?macro=true";
import { default as indexjBvbyAgHxEMeta } from "/home/node/pages/index.vue?macro=true";
import { default as marketplacelrDTAIFnqpMeta } from "/home/node/pages/marketplace.vue?macro=true";
import { default as profileeGIm1KLTdlMeta } from "/home/node/pages/profile.vue?macro=true";
import { default as referral9tSYdVcXjSMeta } from "/home/node/pages/referral.vue?macro=true";
import { default as storyzRKrRYz0MkMeta } from "/home/node/pages/story.vue?macro=true";
export default [
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/node/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "districts",
    path: "/districts",
    meta: districtsZoKyTfNvdAMeta || {},
    component: () => import("/home/node/pages/districts.vue").then(m => m.default || m)
  },
  {
    name: "game",
    path: "/game",
    meta: gameSxUetbtjD0Meta || {},
    component: () => import("/home/node/pages/game.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/node/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "marketplace",
    path: "/marketplace",
    meta: marketplacelrDTAIFnqpMeta || {},
    component: () => import("/home/node/pages/marketplace.vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileeGIm1KLTdlMeta || {},
    component: () => import("/home/node/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: "referral",
    path: "/referral",
    meta: referral9tSYdVcXjSMeta || {},
    component: () => import("/home/node/pages/referral.vue").then(m => m.default || m)
  },
  {
    name: "story",
    path: "/story",
    component: () => import("/home/node/pages/story.vue").then(m => m.default || m)
  }
]